import { Button, Drawer, Form, Select } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import moment from "moment";
import CustomerLayout from "./Layout";
import CustomerHeader from "./Layout/topHeader";
import { EditOutlined } from "@ant-design/icons";

const { Option } = Select;

const CustomerOrderList = () => {
  const [status, setStatus] = useState("");
  const [userId, setUserId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [limit, setLimit] = useState(16);
  const [usersData, setUsersData] = useState({
    loading: false,
    data: null,
  });
  const [usersOptions, setUsersOptions] = useState({
    loading: false,
    list: null,
  });
  const [selectedUser, setSelectedUser] = useState(undefined);

  const fetchRef = useRef(null);
  const route = useParams();

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setMobileNumber("");
    form.resetFields();
  };

  const getUserOrders = useCallback(async () => {
    setUsersData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/order/by-user?` +
          `&userId=${(route as any)?.id || ``}` +
          `&page=${page || 0}` +
          `&limit=${limit || 16}` +
          (status ? `?status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setUsersData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setUsersData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [limit, status, page]);

  // const getUsersOptions = useCallback(
  //   async (mobileNumber) => {
  //     setUsersOptions({ loading: true, list: null });
  //     const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
  //     axios
  //       .get(
  //         `${encodedUri}/admin/user?` +
  //           `page=${0}` +
  //           `&limit=${20}` +
  //           (status ? `&status=${status}` : ``) +
  //           (mobileNumber ? `&mobileNumber=%2B88${mobileNumber}` : ``),
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authenticateToken()}`,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setUsersOptions({
  //           loading: false,
  //           list: res.data?.users?.map((user) => ({
  //             label: user.fullName,
  //             value: user.mobileNumber,
  //           })),
  //         });
  //       })
  //       .catch((err) => {
  //         setUsersOptions({ loading: false, list: [] });
  //         console.error("Users: Error", err);
  //       });
  //   },
  //   [status]
  // );

  useEffect(() => {
    getUserOrders();
  }, [getUserOrders]);

  // const getUsersOptionsDebounce = (mobileNumber) => {
  //   const fetcher = (mobileNumber) => {
  //     getUsersOptions(mobileNumber);
  //   };

  //   return debounce(fetcher, 0.8);
  // };

  // const getUsersOptionsDebounce = React.useMemo(() => {
  //   const loadOptions = (value: string) => {
  //     fetchRef.current += 1;
  //     const fetchId = fetchRef.current;
  //     setUsersOptions({ loading: false, list: null });

  //     if (fetchId !== fetchRef.current) {
  //       return;
  //     }

  //     getUsersOptions(value);
  //   };

  //   return debounce(loadOptions, 800);
  // }, []);

  return (
    <React.Fragment>
      <CustomerLayout userId={(route as any)?.id as string}>
        <div className="bg-white">
          <CustomerHeader leftarea={"Order History"} rightarea={""} />
          {/* <TopHeading total={usersData?.data?.totalElements} />
      <div className="product-searching-area searching-area white-bg section-padding division-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Form form={form} className="d-flex-l">
                <Form.Item name="search">
                  <AutoComplete
                    onSearch={getUsersOptionsDebounce}
                    onSelect={(val) => setMobileNumber(val)}
                    options={usersOptions?.list}
                    defaultActiveFirstOption={false}
                    notFoundContent={
                      usersOptions?.loading ? <Spin size="small" /> : null
                    }
                  >
                    <Input.Search
                      size="large"
                      placeholder="Search by Phone (01...)"
                      onSearch={(val) => setMobileNumber(val)}
                      enterButton
                      loading={usersOptions.loading}
                      pattern={`[0-9]`}
                      maxLength={11}
                    />
                  </AutoComplete>
                </Form.Item>

                <Form.Item>
                  <Select
                    defaultValue={status}
                    placeholder="User Status"
                    onChange={(val) => setStatus(val)}
                    value={status}
                    style={{ minWidth: 250 }}
                  >
                    <Option value={""}>ALL</Option>
                    <Option value={"REGULAR"}>REGULAR</Option>
                    <Option value={"ACTIVE"}>ACTIVE</Option>
                  </Select>
                </Form.Item>
                <Form.Item>
                  <Button
                    style={{
                      height: "40px",
                      marginLeft: 10,
                    }}
                    type="primary"
                    danger
                    onClick={reseAllFieldData}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div> */}
          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-list-items-inner-content">
                    <div className="single-product-wrapper">
                      <div className="single-product-heading">
                        <span>Date & Time</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Order ID</span>
                      </div>
                      <div className="single-product-heading">
                        <span>SubTotal</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Total</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Payment Method</span>
                      </div>
                      {/* <div className="single-product-heading">
                    <span>Status Of Merchant</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status Of DeliveryMan</span>
                  </div> */}
                      <div className="single-product-heading">
                        <span>Status</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {usersData?.loading ? (
                  <Loading />
                ) : (
                  <div className="col-lg-12 product-table">
                    <div className="product-table-area">
                      {usersData?.data?.orders?.length ? (
                        usersData?.data?.orders?.map((order, index) => (
                          <React.Fragment key={index}>
                            {/* <Link to={`/users/${user?.id}`}> */}
                            <div
                              className="single-product-wrapper"
                              onClick={() => setSelectedUser(order)}
                            >
                              <div className="single-product">
                                <span className="name text-capitalize">
                                  {moment(order?.createdAt).format("lll")}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">{order?.orderId}</span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  &#2547;{order?.subTotal || 0}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  &#2547;{order?.total || 0}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {order?.paymentMethod
                                    ?.split("_")
                                    .join(" ")
                                    .toUpperCase()}
                                </span>
                              </div>
                              {/* <div className="single-product">
                            <span className="name">
                              {order?.statusOfMerchant}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {order?.statusOfDeliveryMan}
                            </span>
                          </div> */}
                              <div className="single-product">
                                <span
                                  className={`text-nowrap radius-btn ${order?.status?.toLowerCase()}-btn`}
                                >
                                  {order?.status?.split("_").join(" ")}
                                </span>
                              </div>
                            </div>
                            {/* </Link> */}
                          </React.Fragment>
                        ))
                      ) : (
                        <Empty data="users" />
                      )}
                    </div>
                  </div>
                )}
              </div>

              <PaginationTwo
                {...usersData?.data}
                limit={limit}
                page={getPage(loc.search)}
              />
            </div>
          </div>
        </div>
      </CustomerLayout>
    </React.Fragment>
  );
};

export default CustomerOrderList;
